import toast from "components/Toast/Toast"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Col, Form, FormFeedback, Input, Label, Row, Spinner } from "reactstrap"
import {
  createRole,
  findRoleByName,
  getPermissions,
} from "services/users/calls"
import * as Yup from "yup"

const NewProfile = props => {
  const [isLoading, handleLoading] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [error, setError] = useState([])
  const [permissions, setPermissions] = useState([])

  useEffect(() => {
    handleLoading(true)
    fetchPermissions()
  }, [])

  const fetchPermissions = async () => {
    try {
      const { payload } = await getPermissions()
      const { permissions } = payload
      setPermissions(permissions)
    } catch (error) {
      console.warn(error)
      setError(error)
    } finally {
      handleLoading(false)
    }
  }

  const onCreateOrUpdate = async (name, permissions) => {
    try {
      const found = await findRoleByName(name)
      if (found.payload) {
        toast(
          "warning",
          "Nome já existente, insira um nome diferente.",
          "Aviso"
        )
        return false
      } else {
        try {
          const { payload } = await createRole(name, permissions)
          props.setReRenderList(!props.reRenderList)
          props.setNav(0)
          toast("success", "Perfil criado com succeso.")
        } catch (error) {
          toast("error", error?.message, "Erro")
        } finally {
        }
      }
    } catch (error) {
      setError(error)
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { name: "", permissions: [] },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(3, "Nome muito pequeno")
        .max(255, "Máximo de 255 caracteres permitido para Nome.")
        .required("Campo nome é obrigatório."),
    }),
    onSubmit: (values, { resetForm }) => {
      const { name, permissions } = values
      onCreateOrUpdate(
        name,
        permissions.map(e => Number(e))
      )
      resetForm()
    },
  })

  return (
    <React.Fragment>
      <Row>
        <Form
          className="form-horizontal"
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Row>
              <Col>
                <Label className="form-label">Dados do Perfil</Label>
                <Input
                  name="name"
                  className="form-control"
                  placeholder="Nome do Perfil"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                  autoComplete="off"
                />
                {validation.touched.name && validation.errors.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </div>
          {permissions.length > 0 && (
            <div className="mb-3">
              <Label className="form-check-label">Permissões</Label>
              <br />
              {permissions.map(permission => (
                <div
                  className="form-check mb-1"
                  key={`permission-${permission.id}`}
                >
                  <Input
                    className="mr-2"
                    id={`permission-${permission.id}`}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={permission.id}
                    checked={
                      validation.values.permissions?.includes(
                        String(permission.id)
                      )
                        ? true
                        : false
                    }
                    name="permissions"
                    type="checkbox"
                  />
                  <Label
                    htmlFor={`permission-${permission.id}`}
                    className="form-check-label"
                  >
                    {permission.name}
                  </Label>
                </div>
              ))}
            </div>
          )}
          {isLoading && (
            <div className="mt-3" style={{ textAlign: "center" }}>
              <Spinner className="ms-2" color="primary" />
            </div>
          )}
          {!isLoading && (
            <div className="mt-3 d-grid">
              <button className="btn btn-primary btn-block" type="submit">
                Cadastrar
              </button>
            </div>
          )}
        </Form>
      </Row>
    </React.Fragment>
  )
}

NewProfile.propTypes = {
  t: PropTypes.any,
  reRenderList: PropTypes.bool,
  setReRenderList: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(NewProfile)
